import type { PageIssue } from "@/types/technicalAudit";

export function readSuggestionObject(issue: PageIssue): Record<string, unknown> | null {
	const value = issue.approved_value || issue.proposed_fix || issue.proposed_value;
	if (!value) return null;
	if (typeof value === "string") {
		const trimmed = value.trim();
		if (!trimmed) return null;
		try {
			const parsed = JSON.parse(trimmed);
			return parsed && typeof parsed === "object" && !Array.isArray(parsed)
				? (parsed as Record<string, unknown>)
				: null;
		} catch {
			return { recommendation: trimmed };
		}
	}
	return typeof value === "object" && !Array.isArray(value)
		? (value as Record<string, unknown>)
		: null;
}

export function readSuggestionString(
	suggestion: Record<string, unknown> | null,
	key: string,
): string {
	const value = suggestion?.[key];
	return typeof value === "string" ? value : "";
}

export function readSuggestionList(
	suggestion: Record<string, unknown> | null,
	key: string,
): string[] {
	const value = suggestion?.[key];
	if (!Array.isArray(value)) return [];
	return value.filter((item): item is string => typeof item === "string" && item.trim().length > 0);
}
